import { makeStyles } from "@mui/styles";

const cameraControlStyle = makeStyles((theme) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "8px",
    },
    cameraButtonContainer: {
        position: "absolute",
        bottom: "1.5rem",
        right: "10.2rem",
        zIndex: 1000,
        backgroundColor: "rgba(255 , 255, 255, 0.7)",
        borderRadius: "23px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            right: "13.4rem",
            padding: "0.2rem",
        },
    },
    cameraButton: {
        position: 'relative',
        width: "40px",
        height: "40px",
        display: "flex",
        alignItems: 'center',
        justifyContent: "center",
        zIndex: 1500,
        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
        "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.5)",
        },
        [theme.breakpoints.down("sm")]: {
            transform: "scale(1.1)",
        },
    },
    cameraIcon: {
        fontSize: "35px",
        color: "#333",
        [theme.breakpoints.down("sm")]: {
            transform: "scale(1.2)",
        },
    },
    viewButtonsContainer: {
        position: "absolute",
        bottom: "56px",
        right: "9.6rem",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "8px",
        marginBottom: '10px',
        padding: "10px",
        borderRadius: "15px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
        transition: "opacity 0.3s ease-in-out, visibility 0.3s ease-in-out",
        [theme.breakpoints.down("sm")]: {
            right: "12.9rem",
        },
    },
    viewButton: {
        width: "40px",
        height: "40px",
        backgroundColor: "#f5f5f5!important",
        borderRadius: "23px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1500,
        "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.5)",
        },
        [theme.breakpoints.down("sm")]: {
            transform: "scale(1.1)",
        },
    },
    viewIcon: {
        fontSize: "35px",
        color: "#333",
        [theme.breakpoints.down("sm")]: {
            transform: "scale(1.2)",
        },
    },
    viewButtonsVisible: {
        opacity: 1,
        visibility: "visible",
    },
}));

export default cameraControlStyle;
